var exports = {
  "Bd": "xe30f6088--d1c6bc--footer-mobile",
  "wp": "xe30f6088--d1c6bc--footer-mobile--standard-padding",
  "El": "xe30f6088--d1c6bc--footer-mobile--main-page",
  "KN": "xe30f6088--d1c6bc--footer-mobile--redesign",
  "TS": "xe30f6088--d1c6bc--footer-mobile--adaptive",
};

module.exports = exports;
